import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LaunchpointCoreClientAuthGuard } from '@launchpoint/core-client';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('@launchpoint/core-web').then((m) => m.LaunchpointCoreWebAuthV2Module),
  },
  {
    path: 'sign-up',
    canActivate: [LaunchpointCoreClientAuthGuard],
    loadChildren: () => import('./modules/company-sign-up/company-sign-up.module').then((m) => m.CompanySignUpModule),
  },
  {
    path: 'checkout',
    canActivate: [LaunchpointCoreClientAuthGuard],
    loadChildren: () => import('./modules/app-checkout/app-checkout.module').then((m) => m.AppCheckoutModule),
  },
  {
    path: 'error',
    loadChildren: () => import('@launchpoint/core-web').then((m) => m.AppErrorsCoreModule),
  },
  // {
  //   path: 'sign-up',
  //   canActivate: [LaunchpointCoreClientAuthGuard],
  //   loadChildren: () => import('./modules/sign-up/sign-up.module').then((m) => m.SignUpModule),
  // },
  {
    path: '',
    canActivate: [LaunchpointCoreClientAuthGuard],
    loadChildren: () => import('./layout/layout.module').then((m) => m.LayoutModule),
  },
  { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)], //, {enableTracing:true}
  exports: [RouterModule],
})
export class AppRoutingModule {}
